import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './registerServiceWorker';
import { AppContextProvider } from './common/contexts/AppContext';

ReactDOM.render(<AppContextProvider><App /></AppContextProvider>,document.getElementById('root'));
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js